<span ngForm #frm="ngForm">
<label *ngIf="label" [ngClass]="labelClass">{{label}}<span *ngIf="required">*</span></label>
<mat-form-field [ngClass]="styleClass" [floatLabel]="floatLabel">
  <mat-select *ngIf="compareWith"
              name="{{name}}"
              placeholder="{{ placeholder }}"
              [tabIndex]="tabIndex"
              [disabled]="disabled || readonly"
              [(ngModel)]="_result"
              (selectionChange)="onSelectionChanged($event)"
              panelClass="{{panelClass}}"
              [compareWith]="compareWith"
              maxlength="{{ maxlength }}">
    <mat-option *ngIf="emptyOption" [value]="'null'">{{ emptyOption }}</mat-option>
    <mat-option *ngFor="let option of options | minMaxFilter : value: minValue : maxValue"
                [value]="getValue(option, value)">
      {{getValue(option, display) !== undefined ? getValue(option, display) : getValue(option, value)}}
    </mat-option>
  </mat-select>
    <mat-select *ngIf="!compareWith"
                placeholder="{{ placeholder }}"
                [disabled]="disabled || readonly"
                [(ngModel)]="_result"
                (selectionChange)="onSelectionChanged($event)"
                name="{{name}}"
                panelClass="{{panelClass}}"
                [tabIndex]="tabIndex"
                maxlength="{{ maxlength }}">
    <mat-option *ngIf="emptyOption" [value]="'null'">{{ emptyOption }}</mat-option>
    <mat-option *ngFor="let option of options | minMaxFilter : value: minValue : maxValue"
                [value]="getValue(option, value)" [disabled]="option?.disable">
      {{getValue(option, display) !== undefined ? getValue(option, display) : getValue(option, value)}}
    </mat-option>
  </mat-select>
  <mat-error
      *ngIf="(this.error ||  frm.controls[name]?.errors?.regexp) && frm.controls[name]?.invalid && (frm.controls[name]?.touched || frm.controls[name]?.dirty) ">
        <ng-container *ngIf="frm.controls[name]?.errors?.regexp">
            {{ frm.controls[name]?.errors.regexp }}
        </ng-container>
        <ng-container *ngIf="!frm.controls[name]?.errors?.regexp">
            {{ error }}
        </ng-container>
    </mat-error>
</mat-form-field>
</span>
